import { Component, OnInit, ElementRef, Input, ViewEncapsulation } from '@angular/core';
import { XeroSettingsService } from '../../services';
import { IXeroTokenRecord } from '../../interfaces/xero-token-record';
import { IXeroTokenInfo } from '../../interfaces/xero-token-info';

@Component({
  selector: 'xero-settings',
  templateUrl: './xero-settings.component.html',
  providers: [],
})
export class XeroSettingsComponent implements OnInit {
  constructor(private xeroSettingsService: XeroSettingsService) {}

  public xeroTokenRecord: IXeroTokenInfo = null;
  public showXeroTokenRecord: boolean = false;
  public accessTokenParsed: string = '';

  ngOnInit() {}

  async refreshToken() {
    window.location.href = '/api/xero/xeroAuth/1';
  }

  async viewToken() {
    this.xeroTokenRecord = await this.xeroSettingsService.FetchAllTokens();

    this.showXeroTokenRecord = true;
  }
}
